/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps, Theme } from '@mui/material';

export const orderItemTableRowSX: SxProps<Theme> = {
	'.MuiTypography-body1': {
		lineHeight: 1.5,
	},
	'.MuiTypography-body2': {
		lineHeight: 1.5,
	},
	position:'relative'
};
